import React from 'react';

import Routes from './routes';

import './assets/styles/global.css'

const App: React.FC = () => {
  return (
    <div className="App">
      <Routes />
    </div>
  );
}

export default App;
